import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Row, Statistic } from "antd";
import { getFamilyCount, getPublicationCount } from "../../../services/api-landscape";
import { viewValues, view2cardinalField } from "./utils";

class CountHeader extends Component {
  static propTypes = {
    esUrl: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    mode: PropTypes.oneOf(["sample", "population"]).isRequired,
    view: PropTypes.oneOf(viewValues).isRequired,
    filter: PropTypes.object.isRequired,
    filterPopulation: PropTypes.object.isRequired
  };

  state = {
    cnt: 0,
    cntLoading: false,
    cntLandscape: 0,
    cntLandscapeLoading: false
  };

  componentDidMount() {
    this._isMounted = true;
    this._getCounts(this.props.esUrl, this.props.version, this.props.view, this.props.filter, this.props.filterPopulation);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getCounts(nextProps.esUrl, nextProps.version, nextProps.view, nextProps.filter, nextProps.filterPopulation);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { filter, mode, view } = this.props;
    const alphaThreshold = parseInt(filter.alpha_score);
    const plural = view && view.startsWith("family") ? "FAMILIES" : "PATENTS";
    const { cnt, cntLoading, cntLandscape, cntLandscapeLoading } = this.state;
    return (
      <>
        <h4 style={{ margin: 0 }}>
          {mode === "population"
            ? `${plural} - ENTIRE DATABASE`
            : `${plural} - ABOVE ${alphaThreshold} SIMILARITY`}
        </h4>
        <Row>
          <Col span={12}>
            <Statistic title="Landscape" value={cntLandscape} loading={cntLandscapeLoading} />
          </Col>
          <Col span={12}>
            <Statistic title={<span style={{ color: "#42A5F5" }}>Subset</span>} value={cnt} formatter={this._renderCountWithPct} loading={cntLoading} />
          </Col>
        </Row>
      </>
    );
  }

  _renderCountWithPct = v => {
    const { cntLandscape } = this.state;
    return (
      <>
        <span>{v.toLocaleString()}</span>
        <span style={{ fontSize: "0.6em", opacity: 0.8, marginLeft: 5 }}>({((v * 100) / cntLandscape).toFixed(1)}%)</span>
      </>
    );
  }

  _updateCount = (esUrl, version, view, filter, stateKey) => {
    const loadingStateKey = stateKey + "Loading";
    if (this._isMounted) {
      const apiCallPromise = view.startsWith("family")
        ? getFamilyCount(esUrl, version, filter, view2cardinalField(view))
        : getPublicationCount(esUrl, version, filter);
      this.setState({ [loadingStateKey]: true }, () =>
        apiCallPromise
          .then(res => {
            if (this._isMounted) this.setState({ [stateKey]: res, [loadingStateKey]: false });
          })
          .catch(() => {
            if (this._isMounted) this.setState({ [stateKey]: 0, [loadingStateKey]: false });
          })
      );
    }
  };

  _getCounts = (esUrl, version, view, filter, filterPopulation) => {
    this._updateCount(esUrl, version, view, filter, "cnt");
    this._updateCount(esUrl, version, view, filterPopulation, "cntLandscape");
  };
}

export default CountHeader;
